import { translations as translationsModal } from "../../../../components/single-registry/modals/TemplateDownloadModal/constants";

export const translations = {
  ...translationsModal,
  subtitle: {
    id: "vehicle.single.registry.upload.templateModalWidget.subtitle",
    defaultMessage:
      "Download an empty template to start from scratch or a pre-filled one with your current fleet registered in Edenred solutions. Both include and update vehicles in a single submission.",
  },
  emptySheetDescription: {
    id: "vehicle.single.registry.upload.templateModalWidget.emptySheet.description",
    defaultMessage:
      "Fill in new license plates or enter existing ones to edit them. We identify and import everything.",
  },
};
